import React from "react";
import { PaziaModal } from "components/molecules";
import { ModalPadding } from "../Modals/ModalPadding";
import { CourseTermsFormValues, CreateTermsForm } from "./CreateTermsForm";
import { ModalHeader } from "../Modals/ModalHeader";
import { CourseTermsApi } from "api/courseTermsApi";
import { UpdateTermsForm, UpdateTermsFormValues } from "./UpdateTermsForm";

interface AddTermsModalPropsProps {
  onCloseRequest: () => void;
  terms: CourseTermsApi | null;
  onCreateSubmit: (values: CourseTermsFormValues) => Promise<void>;
  onUpdateSubmit: (values: UpdateTermsFormValues) => Promise<void>;
}

export const AddTermsModalProps = ({
  onCloseRequest,
  terms,
  onCreateSubmit,
  onUpdateSubmit,
}: AddTermsModalPropsProps) => {
  return (
    <PaziaModal id="add-terms-modal" onCloseRequest={onCloseRequest} isOpen={terms !== null} size="2xl">
      <ModalPadding>
        <ModalHeader>Dodaj regulamin</ModalHeader>
        {!terms?.id && <CreateTermsForm onSubmit={onCreateSubmit} onCancel={onCloseRequest} />}
        {terms?.id && <UpdateTermsForm terms={terms} onSubmit={onUpdateSubmit} onCancel={onCloseRequest} />}
      </ModalPadding>
    </PaziaModal>
  );
};
